import { useTranslation } from "react-i18next";
import { NeuButton } from "../../components/neu/Neu";
import { RefBadge } from "../../components/neu/RefBadge";
import { MissingCertificate } from "./MissingCertificate";
import { toneFor } from "./leaveTone";

const TONE = {
  pending: "text-amber-500", approved: "text-success", rejected: "text-destructive",
  completed: "text-success", cancelled: "text-muted-foreground",
  expired: "text-muted-foreground", cancel_requested: "text-amber-500",
};

// كارت طلب مستقل بتصميم 3D Neu وشريط لوني يميّز نوع الإجازة (مرضية/زمنية/طارئة/سنوية...).
export const RequestCardRow = ({ row, onResume, reload }) => {
  const { t } = useTranslation();
  const tone = toneFor(row.leaveType);
  return (
    <div className="relative overflow-hidden rounded-2xl bg-background p-4 shadow-neu" data-testid={`my-request-${row.id}`}>
      <span className={`absolute inset-y-0 start-0 w-1.5 ${tone.bar}`} aria-hidden="true" />
      <div className="flex items-center justify-between gap-3 ps-2">
        <RefBadge value={row.ref} />
        <span className={`shrink-0 text-base font-black ${TONE[row.status] || "text-muted-foreground"}`}>
          {t(`myRequests.status.${row.status}`, { defaultValue: row.status })}
        </span>
      </div>
      <div className="mt-2 flex flex-wrap items-center gap-2 ps-2">
        <span className={`rounded-full px-2.5 py-0.5 text-xs font-black text-white ${tone.bar}`}>{row.typeLabel}</span>
        <p className="truncate text-base font-bold">{row.title}</p>
      </div>
      <p className="mt-1 ps-2 text-sm text-muted-foreground">{row.detail}</p>
      {row.note ? <p className="ps-2 text-sm text-muted-foreground">“{row.note}”</p> : null}
      {row.needCertificate ? <div className="ps-2"><MissingCertificate requestId={row.id} reload={reload} /></div> : null}
      {row.canResume ? (
        <NeuButton variant="danger" className="ms-2 mt-2 px-3 py-1.5 text-sm" data-testid={`leave-resume-${row.id}`}
                   onClick={() => onResume(row.id)}>
          {t("myRequests.resume")}
        </NeuButton>
      ) : null}
    </div>
  );
};
